import { render, staticRenderFns } from "./FormDoencaCid.vue?vue&type=template&id=25efd194"
import script from "./FormDoencaCid.vue?vue&type=script&lang=js"
export * from "./FormDoencaCid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports